import { render } from "./TranslationInner.vue?vue&type=template&id=93a50b12&scoped=true"
import script from "./TranslationInner.vue?vue&type=script&lang=js"
export * from "./TranslationInner.vue?vue&type=script&lang=js"

import "./TranslationInner.vue?vue&type=style&index=0&id=93a50b12&lang=less&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a50b12"]])

export default __exports__